export const bytesToSize = (bytes) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const truncateText = (text, limit = 250) => {
  return text.length > limit ? text.substring(0, limit) + '...' : text;
};

export const formatAmount = (amount) => {
  return `${Number(amount).toFixed(2)} SGD`;
};

export const getClientSites = (clientID) => {
  try {
    const clients = JSON.parse(
      localStorage.getItem('clientSiteOptions') || '[]'
    );
    const client = clients.find(
      (option) => Number(option.id) === Number(clientID)
    );

    return (client?.sites || []).filter((site) => site.active === true);
  } catch (error) {
    return [];
  }
};

export const getSelectedSiteIds = (clientID, siteID) => {
  const sites = getClientSites(clientID);
  const selectedSiteID = Number(siteID);

  if (
    selectedSiteID > 0 &&
    sites.some((site) => Number(site.id) === selectedSiteID)
  ) {
    return [selectedSiteID];
  }

  return sites.map((site) => Number(site.id));
};
